Vendd.Scripts.load(function () {

    var $wrapper = $('.x-brand-search');

    if ($wrapper.length < 1) return;

    //init select2 plugin
    $('select', $wrapper).select2();

    //navigate to brand page
    $('select', $wrapper).on('select2:select', function (e) {
        var $option = $('select', $wrapper).find(':selected');
        var url = $option.data('url');

        window.location.href = url;
    });

    //close select2 popup on scroll
    $(window).scroll(function () {
        $('select', $wrapper).select2('close');
    });

});